<app-splash-screen />
<app-toast-host />
<!--
	The bottom padding is «فاصله از پایین»; it is 0 unless the setting is on.

	On desktop the phone column is centred in a framed body, with the side menu and
	mini-wallet beside it on the right in place of the footer's tabs and قدرت خرید bar.
-->
<div
	class="fixed inset-0 flex flex-col bg-gray-100 pb-(--app-bottom-spacing) md:flex-row md:justify-center md:gap-(--desktop-gap) md:bg-gray-200 md:px-6 md:py-(--desktop-padding-y)">
	@if (isDesktop()) {
		<aside
			class="flex w-(--desktop-side-panel-width) shrink-0 flex-col gap-1.5 overflow-y-auto"
			data-cy="desktop-side-panel">
			<app-side-menu class="min-h-140 shrink-0" />
			<app-wallet-mini class="shrink-0" />
		</aside>
	}

	<div
		class="flex min-h-0 flex-1 flex-col md:w-(--desktop-column-width) md:flex-none md:overflow-hidden md:rounded-2xl md:bg-gray-100 md:p-2.5">
		<connection-state class="shrink-0" />
		<app-header class="shrink-0 md:overflow-hidden md:rounded-2.5" [class.md:rounded-b-none]="headerAttached()" />
		<main class="min-h-0 flex-1 overflow-y-auto">
			<router-outlet />
		</main>
	</div>

	@if (!isDesktop()) {
		<app-footer class="shrink-0" />
	}
</div>
